var map = {
	"./1. pitha udsob 2.JPG": 7628,
	"./7. Footbal Celebration2 1-25.JPG": 9573,
	"./Akij-Insaf-logo.JPG": 8959,
	"./DSC01228.JPG": 2825,
	"./Md. Abu .jpg": 6712,
	"./afvs.jpg": 3291,
	"./afvs1.jpg": 3382,
	"./afvs2.jpg": 81,
	"./ak.azad.jpg": 8439,
	"./akij-foundation-school-and-college.jpg": 6225,
	"./akij-house-3.jpg": 5045,
	"./akij-map.jpg": 9911,
	"./akij-uddin.png": 4537,
	"./alim.jpg": 7238,
	"./asvf-logo.png": 1135,
	"./bayejid.jpg": 2105,
	"./building1.jpg": 1950,
	"./bulding2.JPG": 5609,
	"./car-training.jpg": 1718,
	"./class1.JPG": 3389,
	"./class2.JPG": 2946,
	"./contact-img.png": 1245,
	"./faridul.jpg": 4344,
	"./fire safty1.jpg": 5671,
	"./fire-safty2.jpg": 9121,
	"./hasan.ali.jpg": 2952,
	"./hasibul.jpg": 9157,
	"./jamil-sir.jpg": 3977,
	"./kalam.jpg": 4937,
	"./kawser.jpg": 4664,
	"./km.rakib.jpg": 1282,
	"./manikhasan.jpg": 7566,
	"./masudur.jpg": 2464,
	"./md.ariful.jpg": 9887,
	"./md.mizanur.jpg": 2754,
	"./md.rezaul.jpg": 31,
	"./mission.png": 4993,
	"./mohibullah.jpg": 4150,
	"./mohiuddin.jpg": 5936,
	"./nafi.jpg": 143,
	"./noyon.jpg": 198,
	"./nuralom.jpg": 5307,
	"./obaidur.jpg": 9653,
	"./photo-placeholder.png": 5163,
	"./rafi.jpg": 5739,
	"./raju.jpg": 5763,
	"./rezaul.kabir.jpg": 9897,
	"./shahariar.jpg": 6238,
	"./shahdat.jpg": 8642,
	"./shamim.jpg": 7354,
	"./shofiqul.jpg": 1136,
	"./vision.png": 7259,
	"./woman-placeholder..jpg": 7103,
	"./work1.jpg": 7479,
	"./work10.jpg": 8487,
	"./work2.jpg": 2728,
	"./work3.JPG": 5108,
	"./work4.jpg": 1246,
	"./work5.jpg": 2731,
	"./work6.jpg": 6284,
	"./work7.jpg": 4329,
	"./work8.jpg": 5618,
	"./work9.jpg": 7999,
	"./zakir.jpg": 3212,
	"./zubayer.jpg": 3883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;